import { render } from "./Hobbies.vue?vue&type=template&id=71821176&scoped=true"
import script from "./Hobbies.vue?vue&type=script&lang=js"
export * from "./Hobbies.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-71821176"

export default script